import { useDispatch, useSelector } from "react-redux";
import { fetchLocalData, saveLocalData } from "../helpers/storage-helper";
import { authActions } from "../store/auth";
import { endPoints } from "../config/end-points";
import jwt_decode from "jwt-decode";
import axios from "axios";

const useAuth = () => {
  const data = fetchLocalData("sitebuilder_user");
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const dispatch = useDispatch();

  // Fetch fresh whitelabel from server and update localStorage + Redux
  const refreshWhitelabel = async (token) => {
    try {
      const res = await axios.get(endPoints.whitelabelGet, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.status === 200) {
        const wl = res.data.body || null;
        // Check if any values are set (not all empty)
        const hasValues = wl && (wl.logo || wl.favicon || wl.site_title || wl.footer_text);
        const whitelabel = hasValues ? wl : null;

        dispatch(authActions.setWhitelabel(whitelabel));
        const stored = fetchLocalData("sitebuilder_user");
        if (stored) {
          stored.whitelabel = whitelabel;
          saveLocalData("sitebuilder_user", stored);
        }
      }
    } catch (e) {
      // Silently fail — use cached whitelabel
    }
  };

  const isLogin = () => {
    if (data?.id) {
      const { exp } = jwt_decode(data.token);

      const expirationTime = exp * 1000 - 60000;
      if (Date.now() >= expirationTime) {
        localStorage.clear();
        return false;
      } else {
        if (!isAuthenticated) {
          dispatch(
            authActions.login({
              token: data.token,
              roles: data.roles,
              first_name: data.first_name,
              last_name: data.last_name,
              access: data.access,
              email: data.email,
              whitelabel: data.whitelabel,
            })
          );
          // Fetch fresh whitelabel in background (non-blocking)
          refreshWhitelabel(data.token);
        }
        return true;
      }
    } else {
      return false;
    }
  };

  return { isLogin };
};

export default useAuth;
